import styled from "styled-components";

export const Container = styled.div`
  margin-right: 15px;
`;
